module.exports = __webpack_public_path__ + "images/price-drops-blue-f0cc1b35.svg";